import { Table } from 'antd';

import { inject, observer } from 'mobx-react';
import React from 'react';
import { ConsultaImpuestos } from '../../models';
import { ConsultasTableColumns } from '../../models/ConsultasTables';

import consultaStore, { ConsultaStore } from '../../stores/consultaStore';

interface ConsultasTableProps {
    consultaStore?: ConsultaStore;
}

@inject('consultaStore')
@observer
class ConsultasTables extends React.Component<ConsultasTableProps> {
    state = {
        filterDropdownVisible: false,
        data: this.props.consultaStore!.forms,
        searchText: ''
    };

    async componentDidMount() {
        const { consultaStore } = this.props;
        //await consultaStore!.getConsulta(true);
        this.setState({ data: consultaStore!.forms });
    }

    onRow = (record: ConsultaImpuestos, index: number) => ({
        onClick: () => this.handleFila(record)
    });

    handleFila = async (record: ConsultaImpuestos) => {
        const response = await this.props.consultaStore!.getReportePdf(record);
        if (!response) {
            return;
        }

        const type = 'application/pdf';
        const blob = new Blob([response!.data], { type });

        const fileDownload = require('react-file-download');
        fileDownload(blob, record.municipioNombre
            + consultaStore.mesString(record.mes)
            + record.ejercicio
            + '.pdf');
    };

    render() {
        const { consultaStore } = this.props;
        return (
            <>
                <Table
                    columns={ConsultasTableColumns}
                    dataSource={consultaStore!.forms}
                    onRow={this.onRow}
                    rowKey="consultaId"
                    pagination={{ pageSize: 8 }}
                    bordered={true}
                    loading={consultaStore!.cargando}
                />
            </>
        );
    }
}
export default ConsultasTables;
